import { createReducer, on } from "@ngrx/store";
import { initialDigLitSelfAssessmentState } from "./dig-lit-self-assessment.state";
import { GetDigLitSelfAssessmentData, GetDigLitSelfAssessmentDataError, GetDigLitSelfAssessmentDataSuccess, ResetDigLitSelfAssessmentState, SaveDigLitSelfAssessment, SaveDigLitSelfAssessmentError, SaveDigLitSelfAssessmentSessionError, SaveDigLitSelfAssessmentSuccess, SetDigLitState } from "./dig-lit-self-assessment.actions";
import { DigLitSelfAssessmentState } from "./dig-lit-self-assessment.state";
import { setInitialState } from "./dig-lit-self-assessment.utils";

export const DigLitSelfAssessmentReducer = createReducer(
	initialDigLitSelfAssessmentState,

	on(GetDigLitSelfAssessmentData, (state): DigLitSelfAssessmentState => {
		return { 
			...state,
			loader: true
		}
	}),
	on(GetDigLitSelfAssessmentDataSuccess, (state, action): DigLitSelfAssessmentState => {
		return { 
			...state, 
			data: setInitialState(state, action),
			loader: false
		}
	}),
	on(GetDigLitSelfAssessmentDataError, (state, action): DigLitSelfAssessmentState => {
		return {
			...state,
			loader: false,
			error: action.error
		}
	}),
	on(SaveDigLitSelfAssessment, (state): DigLitSelfAssessmentState => {
		return {
			...state,
			loader: true
		}
	}),
	on(SaveDigLitSelfAssessmentSuccess, (state, action): DigLitSelfAssessmentState => {
		return {
			...state,
			loader: false,
			saveResult: action.result
		}
	}),
	on(SaveDigLitSelfAssessmentError, (state, action): DigLitSelfAssessmentState => {
		return {
			...state,
			loader: false,
			error: action.error
		}
	}),
	on(SaveDigLitSelfAssessmentSessionError, (state, action): DigLitSelfAssessmentState => {
		return {
			...state,
			loader: false,
			error: action.error
		}
	}),
	on(SetDigLitState, (state, action): DigLitSelfAssessmentState => {
		return {
			...state,
			data: action.state,
			currentPage: action.state.currentPage,
			isDirty: true
		}
	}),
  on(ResetDigLitSelfAssessmentState, (): DigLitSelfAssessmentState => {
    return { ...initialDigLitSelfAssessmentState };
  })
);